

































































import Vue from "vue";
import VueSlider from "vue-slider-component";

export default Vue.extend({
  props: ["filters"],

  components: { VueSlider },

  data: () => ({
    customPrice: { min: 0, max: 7500 }, // for custom price range
    priceRange: [0, 7500]
  }),

  created() {},

  methods: {
    applyPriceChange() {
      this.filters.pricesSelected.price_min = this.customPrice.min;
      this.filters.pricesSelected.price_max = this.customPrice.max;
    },

    onPriceSliderChange(values) {
      console.log("onPriceSliderChange");
      this.customPrice.min = values[0];
      this.customPrice.max = values[1] < 8500 ? values[1] : "8000+";

      this.applyPriceChange();
    }
  }
});
